export default "__VITE_ASSET__B$gf5uQu__"